import { render, staticRenderFns } from "./UnpublishedMessage.vue?vue&type=template&id=0910a78d&scoped=true&"
import script from "./UnpublishedMessage.vue?vue&type=script&lang=ts&"
export * from "./UnpublishedMessage.vue?vue&type=script&lang=ts&"
import style0 from "./UnpublishedMessage.vue?vue&type=style&index=0&id=0910a78d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0910a78d",
  null
  
)

export default component.exports